import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { doctorProfilePropType } from '../../../../../propTypes/index';
import styles from './doctorProfile.module.css';

const getInitials = name => {
  const initials = name
    .replace(/Dr\.?/, '')
    .trim()
    .split(' ');
  return initials[0].slice(0, 1) + initials[1].slice(0, 1);
};

const DoctorProfile = ({ toggleDoctorProfile, doctor }) => (
  <div className={styles.container}>
    {doctor.ProfilePictureURL ? (
      <img
        className={styles.doctorImg}
        src={doctor.ProfilePictureURL}
        alt={doctor.Name}
        onClick={() => toggleDoctorProfile(doctor.PmsUserId, moment(), true)}
      />
    ) : (
      <div className={styles.doctorInitials}>{getInitials(doctor.Name)}</div>
    )}
    <div className={styles.textContainer}>
      <div
        className={styles.doctorName}
        onClick={() => toggleDoctorProfile(doctor.PmsUserId, moment(), true)}
      >
        {doctor.Name}
      </div>
      {doctor.ShowLocation && (
        <div className={styles.location}>{doctor.Location}</div>
      )}
      <div className={styles.type}>{doctor.Type}</div>
      {doctor.Description.length < 60 ? (
        <div className={styles.description}>{doctor.Description}</div>
      ) : (
        <div className={styles.description}>
          {doctor.Description.substr(0, 56)}
          ...
          <div
            className={styles.readMore}
            onClick={() =>
              toggleDoctorProfile(doctor.PmsUserId, moment(), true)
            }
          >
            {' '}
            Read more{' '}
          </div>
        </div>
      )}
    </div>
  </div>
);

DoctorProfile.propTypes = {
  toggleDoctorProfile: PropTypes.func.isRequired,
  doctor: doctorProfilePropType.isRequired,
};

export default DoctorProfile;
